import { ProjectFestival } from '@/domain/project-festival/entities/project-festival.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Result = ProjectFestival;

export const getProjectFestival = createAppAsyncThunk(
  'projectFestival/getProjectFestival',
  async (
    id: number,
    { extra: { projectFestivalGateway, snackbarGateway } },
  ): Promise<Result> => {
    try {
      const project = await projectFestivalGateway.get(id);
      return project;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetProject.Message.error'));
}
